import React, { useState, useEffect } from "react";
import { Button, Row, Col, Form, Input, notification } from "antd";
import ClipLoader from "react-spinners/ClipLoader";
import { resetPasswordStyles } from "./ResetPasswordStyles";
import ava1 from "../../assets/images/my-friend-logo-blue.svg"; 
import { useNavigate } from "react-router-dom";
import { resetNewPassword } from "../../api/password"; 
import Footer from "../../components/layout/Footer";
import constants from "../../constants/constants";

export const ResetPassword = ({ onOnboardingComplete}) => {
  const navigate = useNavigate();
  
  const [form] = Form.useForm();
  const [loader, setLoader] = useState(false);
  const [token, setToken] = useState(""); 

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const tokenFromUrl = queryParams.get('token');
    setToken(tokenFromUrl || "");
  }, []);

  const onFinish = async (values) => {
    setLoader(true);
    const { newPassword, confirmNewPassword } = values;
    try {
      const response = await resetNewPassword({ newPassword, confirmNewPassword, token });
      setLoader(false);
      if (response.error) {
        notification.error({
          message: "Error",
          description: response.error,
        });
      } else {
        notification.success({
          message: "Success",
          description: constants.passwordReset,
        });
        localStorage.setItem('onboardingComplete', 'true');
        onOnboardingComplete();
        navigate('/signin', { replace: true });
      }
    } catch (error) {
      console.log(error);
      notification.error({
        message: "Error",
        description: error.error
      });
      setLoader(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    notification.error({
      message: "Failed",
      description: errorInfo,
    });
  };

  return (
    <div style={{ maxHeight: "100dvh", overflow: "hidden" }}>
      <Row>
        <Col lg={24} md={24} xs={24}>
          <div
            style={resetPasswordStyles.container1}
          >
            <div
              style={resetPasswordStyles.container2}
            >
              <div style={resetPasswordStyles.logoContainer}>
                <img
                  style={resetPasswordStyles.logoStyle}
                  src={ava1}
                  alt="logo"
                />
              </div>
              <div style={resetPasswordStyles.marginAuto}>
                <span style={resetPasswordStyles.resetHeading}>
                  Reset Password
                </span>
              </div>
              <div style={resetPasswordStyles.marginAuto}>
                <span style={resetPasswordStyles.resetDescription}>
                  Enter your new password to reset
                </span>
              </div>
              <Form
                form={form}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                layout="vertical"
              >
                <Form.Item
                  className="reset-password-new"
                  label="New Password"
                  name="newPassword"
                  rules={[
                    { required: true, message: constants.newPassword },
                    { min: 8, message: constants.newPasswordMin }
                  ]}
                  style={resetPasswordStyles.formInput}
                >
                  <Input.Password placeholder="New Password" />
                </Form.Item>
                <Form.Item
                  className="reset-password-confirm"
                  label="Confirm New Password"
                  name="confirmNewPassword"
                  dependencies={['newPassword']}
                  rules={[
                    { required: true, message: "" },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue('newPassword') === value) {
                          return Promise.resolve(constants.confirmPassword);
                        }
                        return Promise.reject(new Error(constants.passwordMatch));
                      },
                    }),
                  ]}
                  style={resetPasswordStyles.formInput}
                >
                  <Input.Password placeholder="Confirm New Password" />
                </Form.Item>
                <Form.Item style={resetPasswordStyles.centerFormButton}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    style={resetPasswordStyles.resetButton}
                  >
                    {loader ? (
                      <ClipLoader
                        color="#fff"
                        loading={loader}
                        size={15}
                        aria-label="Loading Spinner"
                        data-testid="loader"
                      />
                    ) : (
                      <span>Reset Password</span>
                    )}
                  </Button>
                </Form.Item>
              </Form>
             
            </div>
          </div>
        </Col>
      </Row>
      <Footer />
    </div>
  );
};

export default ResetPassword;
